export type TapTraitAttribute = {
	name: string;
	value: string;
};

export const formatTapTraits = (
	tapTraits?: Record<string, unknown>,
): TapTraitAttribute[] | null => {
	if (!tapTraits || Object.entries(tapTraits).length === 0) {
		return null;
	}

	return Object.entries(tapTraits).reduce<TapTraitAttribute[]>(
		(acc, [name, value]) => [...acc, { name, value: String(value) }],
		[],
	);
};
